import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `cypress`,

  name: {
    [LOCALES.EN_US]: `Cypress`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.framework, TYPES.tool],

  tags: [],
} as const satisfies TTerm
